export const ACCOUNT_PURPOSES = [
  { id: "PAY_BILLS", label: "accountPurposes.pay.bills" },
  { id: "MONEY_TO_FROM_FAMILY", label: "accountPurposes.money.to.from.family" },
  { id: "DIVIDENDS", label: "accountPurposes.dividends" },
  { id: "SAVINGS", label: "accountPurposes.savings" },
  {
    id: "PERSONAL_BUSINESS_PURPOSES",
    label: "accountPurposes.personal.business.purposes",
  },
  { id: "PENSION", label: "accountPurposes.pension" },
  { id: "CRYPTO", label: "accountPurposes.crypto" },
  { id: "SALARY", label: "accountPurposes.salary" },
  { id: "LOTTERY_GAMING", label: "accountPurposes.lottery.gaming" },
  { id: "RECONCILIATION", label: "accountPurposes.reconciliation" },
  { id: "VIRTUAL_ACCOUNT", label: "accountPurposes.virtual.account" },
  { id: "CURRENCY_EXCHANGE", label: "accountPurposes.exchange" },
  { id: "OTHER", label: "accountPurposes.other" },
];
